import { useEffect, useRef, useState } from "react";
import * as echarts from "echarts";
import ReactEcharts from "echarts-for-react";
import Agent from "../../../Network/Agent";
export default function Availability({ lockedTenantId }) {
    const [siteOption, setSiteOption] = useState({});
    const [dcOption, setDcOption] = useState({});
    const [gridOption, setGridOption] = useState({});
    const availabilityControllerRef = useRef(null);
    const [dcFilterType, setDcFilterType] = useState('date');
    const today = new Date().toISOString().split("T")[0];
    const from_date = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split("T")[0];
    const [dcDateValue, setDcDateValue] = useState({ from: from_date, to: today });
    const [tempDate, setTempDate] = useState(from_date);
     const [tempDate2, setTempDate2] = useState(today);
     const [tenantId, setTenantId] = useState(lockedTenantId ? String(lockedTenantId) : '');
    const [loading, setLoading] = useState(true);
    const array_data = {
        from_date: dcDateValue.from,
        to_date: dcDateValue.to,
        tenant_id: tenantId
    };
    const [showModal, setShowModal] = useState(false);

       const openDateModal = () => {

        setShowModal(true);
    };
    
    const getDateOptionLabel = (range) => {
        if (!range?.from || !range?.to) {
            return 'Date';
        }
        if (range.from === range.to) {
            return `Date (${range.from})`;
        }
        return `Date (${range.from} to ${range.to})`;
    };

    const fetchData = () => {
        if (availabilityControllerRef.current) {
            availabilityControllerRef.current.abort();
        }
        const controller = new AbortController();
        availabilityControllerRef.current = controller;

        const signal = controller.signal;
        setLoading(true);

        Agent.MANAGEMENT_DASHBOARD.availability(array_data, signal)
            .then((response) => {
                console.log("Availability data:", response.data);
                setSiteOption(availabilityChartOption(response.data.data.site_availability_graph, "Site Availability", "#43A047",
    "#66BB6A"));
                setDcOption(availabilityChartOption(response.data.data.dc_power_graph, "Dc Availability", "#2196F3", "#64B5F6"));
                setGridOption(availabilityChartOption(response.data.data.grid_availability_graph, "Grid Availability", "#FF9800", "#FFB74D"));
            })
            .catch((error) => {
                console.error("Error fetching availability data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
        return () => {
            if (availabilityControllerRef.current) {
                availabilityControllerRef.current.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (lockedTenantId) {
            setTenantId(String(lockedTenantId));
        }
    }, [lockedTenantId]);

    useEffect(() => {
        fetchData();
    }, [dcDateValue, tenantId]);

const availabilityChartOption = (data, title, color1, color2) => {

  return {

    title: {
      text: title,
      left: "center",
      top: 5,
      textStyle: {
        fontSize: 15,
        fontWeight: 600,
        color: "#333"
      }
    },

    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },

    grid: {
      left: "3%",
      right: "6%",
      top: 45,
      bottom: "5%",
      containLabel: true
    },

    xAxis: {
      type: "value",
      splitLine: {
        lineStyle: {
          color: "#E5E7EB"
        }
      }
    },

    yAxis: {
      type: "category",
      inverse: true,
      data: Object.keys(data),
      axisTick: { show: false }
    },

    series: [
      {
        type: "bar",
        data: Object.values(data),

        barWidth: 18,
        showBackground: true,

        backgroundStyle: {
          color: "rgba(180,180,180,0.1)"
        },

        itemStyle: {
          borderRadius: [0,6,6,0],
          color: new echarts.graphic.LinearGradient(0,0,1,0,[
            {offset:0,color:color1},
            {offset:1,color:color2}
          ])
        },

        label: {
          show: true,
          position: "right",
          fontWeight: 600,
          color: "#333"
        },

        animationDuration: 800
        
      }
    ]
  };

};

    return (
        <div className="row g-1 position-relative">
            {lockedTenantId && loading && (
                <div className="td-chart-loading">
                    <span className="spinner-border spinner-border-sm" />
                    <span>Loading graph...</span>
                </div>
            )}
            <div className="col-md-12">
                <div className="float-end">
                    <div className="input-group input-group-sm">

                    {!lockedTenantId && (
                    <select className="form-select form-select-sm" value={tenantId} onChange={(e) => setTenantId(e.target.value)}>
                        <option value="">All Tenants</option>
                        <option value="1">BL</option>
                        <option value="3">Robi</option>
                        <option value="4">GP</option>
                    </select>
                    )}
  <select
                    className="form-select form-select-sm"
                    value={dcFilterType}
                    onClick={() => {
                        if (dcFilterType === 'date') {
                            openDateModal();
                        }
                    }}
                    onChange={(e) => {
                        setDcFilterType(e.target.value);
                        if (e.target.value === 'date') {
                            openDateModal();
                        }
                    }}
                >

                    <option value="date">{getDateOptionLabel(dcDateValue)}</option>
                </select>
                
                    </div>
                </div>
              
            </div>
            <div className="col-6">
                <div className="card mb-0">
                    <div className="card-body m-0 p-0">

                        <ReactEcharts style={{ height: "200px" }} option={siteOption} />
                    </div>
                </div>
            </div>
            <div className="col-6">
                <div className="card mb-0">
                    <div className="card-body m-0 p-0">
                        <ReactEcharts style={{ height: "200px" }} option={dcOption} />
                    </div>
                </div>
            </div>
            <div className="col-6 mt-3">
                <div className="card">
                    <div className="card-body m-0 p-0">

                        <ReactEcharts style={{ height: "200px" }} option={gridOption} />
                    </div>
                </div>
            </div>
             {/* Date Filter Modal */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Date</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">From Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={tempDate}
                                        onChange={(e) => setTempDate(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">To Date</label>
                                    <input type="date" className="form-control"
                                        value={tempDate2}
                                        onChange={(e) => setTempDate2(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => {

                                        setDcDateValue({ from: tempDate, to: tempDate2 });
                                        setShowModal(false);
                                    }}
                                >
                                    <i className="fa-solid fa-filter me-1"></i>
                                    Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
}